import { Component, OnDestroy, type OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { AlertService } from 'src/app/components/alert/alert.service';
import { IDetailedOperationKPI, IKpiObject, IKpiResponse, IOperationKPI } from 'src/app/modules/shared/models/operation.model';
import { LoggerService } from 'src/app/services/logger.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { DashboardService } from '../dashboard/dashboard.service';
import { CommonUtils } from 'src/app/utils/CommonUtils';
import { EPolicyCompany } from 'src/app/modules/shared/models/policy.model';

@Component({
  selector: 'app-kpi',
  templateUrl: './kpi.component.html',
  styleUrl: './kpi.component.scss',
})
export class KpiComponent implements OnInit, OnDestroy {

  kpis: IDetailedOperationKPI[] = [];
  countersType: 'number' | 'premium';
  destroy$ = new Subject();

  constructor(
    private readonly _spinner: SpinnerService,
    private readonly _dashboardService: DashboardService,
    private readonly _alertService: AlertService
  ) { }
  
  ngOnInit(): void {
    this.getKpis();
  }

  getCompanyLogo(companyId: string): string {
    return CommonUtils.getCompanyImage(companyId);
  }

  getKpis() {
    this._spinner.show();
    this._dashboardService.getMonthlyKpis()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: response => {
          LoggerService.logInfo(this.constructor.name, 'getKpis', { response });
          this.kpis = this.manageCompaniesKpis(response);
          this._spinner.hide();
        },
        error: error => {
          LoggerService.logError(this.constructor.name, 'getKpis', { error });
          this._alertService.openErrorMessage('', 'getKpis', error);
          this._spinner.hide();
        }
      })
  }

  manageCompaniesKpis(object: IKpiResponse): IDetailedOperationKPI[] {
    const companyMapping: { [key: string]: string } = {
      [EPolicyCompany.ATHORA]: 'athora',
      [EPolicyCompany.ISV]: 'intesa'
    };
    this.countersType = CommonUtils.checkAndGet(object, 'type', null);
    return Object.keys(companyMapping).map(companyId => {
      const companyKey = companyMapping[companyId];
      return {
        companyId,
        kpis: CommonUtils.manageGeneralKpis(CommonUtils.checkAndGet(object, companyKey, null))
      };
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

}
